import { createContext, useContext } from "react";

import { PlaybookContextApi } from "./hooks/use-playbook-context";

export const PlaybookContext = createContext<PlaybookContextApi>({
  addingPlay: false,
  setAddingPlay: () => undefined,
  selectedPlaybook: undefined,
  setSelectedPlaybook: () => undefined,
  playsToAdd: [],
  setPlaysToAdd: () => undefined,
  selectedPlaybookPlayIds: [],
  addPlaysToPlaybook: () => Promise.resolve(),
  removePlaysFromPlaybook: async () => undefined,
  //movePlay: () => undefined,
  movePlayLocal: () => undefined,
  localPlaybook: undefined,
  saveLocalPlaybook: async () => undefined,
  editingPrintSettings: false,
  setEditingPrintSettings: () => undefined,
  printSettings: [],
  setPrintSettings: () => undefined,
  printSettingsOptions: {},
  renderingPDF: false,
  playbookError: false,
  playbookPDFUrl: "",
});

export const usePlaybookContext = () => useContext(PlaybookContext);
